export default "/_next/static/sounds/badge-4cd45701bf1e04121134da61b5924c3c.mp3";